module.exports = __webpack_public_path__ + "static/media/software-Companies-755x420.4ab3a3d8.jpg";